import DateCellRenderer from '../agGrid/cellRenderers/dateCellRenderer.component';
import { alignLeftCellStyle } from '@common/cellStyles';

import {
  accountColumnDefinition,
  descriptionColumnDefinition,
  enabledFlagColumnDefinition,
  allowAccountBasedAdjustmentsColumnDefinition,
  createdByColumnDefinition,
  updatedByColumnDefinition,
  updatedOnColumnDefinition,
  preTaxColumnDefinition,
} from '../columnDefinitions';

export default categories => ([
  {
    ...accountColumnDefinition,
    width: 120,
    minWidth: 100,
  },
  {
    ...descriptionColumnDefinition,
    width: 280,
    minWidth: 260,
  },
  preTaxColumnDefinition,
  {
    ...enabledFlagColumnDefinition,
    width: 80,
    minWidth: 80,
  },
  allowAccountBasedAdjustmentsColumnDefinition,
  ...categories.map(({ categoryName, description }) => ({
    headerName: description,
    field: categoryName,
    minWidth: 180,
    ...alignLeftCellStyle,
  })),
  {
    headerName: 'Created On',
    field: 'createdOn',
    width: 180,
    minWidth: 160,
    cellRenderer: DateCellRenderer,
    ...alignLeftCellStyle,
  },
  {
    ...createdByColumnDefinition,
    width: 200,
    minWidth: 180,
  },
  {
    ...updatedByColumnDefinition,
    width: 200,
    minWidth: 180,
  },
  {
    ...updatedOnColumnDefinition,
    width: 180,
    minWidth: 160,
  },
]);
